module.exports = __webpack_public_path__ + "media/images/moov-africa-grey-7a0ccc1f5a0488dd6adeb07072d9bcc1.jpeg";